import * as ConstantRouter from '@/constant/router'

const route = {
  path: '/competitor/:jsId?/login',
  name: ConstantRouter.COMPETITOR_LOGIN,
  component: () => import(/* webpackChunkName: "competitor-login" */ '@/competitor/login')
}

export default route
